export const types = {
  sesion: "[LOGIN] Iniciar Sesión",
  otro:'',
  usuario: "[DATOS USUARIO]",
  Loading: "[Loading]",
  clienteinput: "[Cliente Buscado]",
  clienteselected: "[Cliente Seleccionado]",
  idcliente: "[ID Cliente]",
  clientesArray: "[Cliente Array]",
  disabled: "[Desahabilitar control]",
  clientes: "[Acutalizacion de cliente]",
  tapselected: "[Opcion seleccionada]",
  clima:"[CLIMA] Actualizar clima",
};
